import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'price',
  standalone: true
})
export class PricePipe implements PipeTransform {
  transform(value: any, symbol?: string): string {
    if (value == null || value === '') return value;

    // Try extracting a valid number
    const numericValue = parseFloat(value.toString().replace(/[^\d.-]/g, ''));

    if (isNaN(numericValue)) {
      // Not a number: return original string (like "Call us" or "Soon Update")
      return value;
    }

    const formatter = new Intl.NumberFormat('en-US');
    const formattedValue = formatter.format(numericValue);

    return symbol ? `${symbol} ${formattedValue}` : formattedValue;
  }
}
